import React, { Component } from "react";
import { Wrapper, Card, Title, Copy } from "app/NativeComponents/common";
import { RadioButton, PillButton } from "app/NativeComponents/snippets";

class SelectToNumber extends Component {
  render() {
    //get state name Array

    const { phone_numbers, selected_number } = this.props.fields;
    if (phone_numbers && phone_numbers.length > 0) {
      return (
        <Wrapper>
          <Card>
            {phone_numbers.map((phone_number, i) => {
              return (
                <RadioButton
                  key={i}
                  onPress={() => {
                    this.props.updateField({
                      prop: "selected_number",
                      value: phone_number
                    });
                  }}
                  value={
                    selected_number &&
                    phone_number.owner_phone_number_id ==
                      selected_number.owner_phone_number_id
                      ? true
                      : false
                  }
                  title={phone_number.phone_number}
                  text={phone_number.phone_label}
                  style={{
                    borderBottomWidth: 1,
                    borderBottomColor: this.props.colors.border_color,
                    borderBottomStyle: "solid"
                  }}
                />
              );
            })}
          </Card>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default SelectToNumber;
